export default {"src":"/_next/static/media/box-food-packs.f9eb0c22.svg","height":73,"width":202,"blurWidth":0,"blurHeight":0};